<template>
    <div>
      <header-one />
      <main>
        <router-view />
      </main>
      <footer-one />
      <back-to-top />
      <modal-product />
    </div>
  </template>
  
  <script>
  import HeaderOne from '../components/test/HeaderOne.vue';
  import FooterOne from '../components/test/FooterOne.vue';
  import BackToTop from '../components/test/BackToTop.vue';
  import ModalProduct from '../components/test/ModalProduct.vue';
  
  export default {
    components: {
      HeaderOne,
      FooterOne,
      BackToTop,
      ModalProduct,
    },
  };
  </script>
  
  <style scoped>
  /* Add any global layout styles here */
  </style>
  